export default {"src":"/_next/static/media/unverified.552eab01.svg","height":16,"width":16,"blurWidth":0,"blurHeight":0};